<template>
    <div class="btm-position">
        <!-- <el-row type="flex" justify="center">
            <el-col :md="22" :sm="22" :xs="22" style="padding: 50px 0 20px;border-bottom: 1px solid #ebe6e6;">
                <img  :src="scanimg" height="50px" class="btm-logo" />
            </el-col>
        </el-row> -->
        <el-row type="flex" justify="center" class="all-address">
            <el-col :md="22" :sm="22" :xs="22">
                <el-col :md="24"   justify="space-between">
                    <el-col :md="3">
                        <img  :src="scanimg" height="40px" class="btm-logo" />
                    </el-col>
                    <el-col :md="7">
                        <div class="address">
                            <!-- {{ $t('home.botBar.left.title') }} -->
                            <p class="iconfont mh-location" style="font-size: 30px;"></p>
                        </div>
                        <div class="address " v-for="(item,index) in $t('home.botBar.left.cpns')" :key="index">
                            <span class="hvr-bounce-in">{{item.cpn}}</span>
                            <span class="hvr-bounce-in">{{item.address}}</span>
                        </div>
                    </el-col>
                    
                    <el-col :md="5" :xs="24" class="link-m">
                        <el-col :xs="12" class="lineMethod " v-for="(item,index) in $t('home.botBar.center')" :key="index">
                                <span  class="iconfont" :class="item.icon" style="font-size: 30px;"></span>
                                <span class="hvr-bounce-in">{{item.content}}</span>
                        </el-col>
                    </el-col>
                    <el-col :md="3" :xs="24" class="hidden-sm-and-down">
                        <div class="address">
                            <!-- {{ $t('home.botBar.left.title') }} -->
                            <p class="iconfont mh-youqinglianjie" style="font-size: 30px;"></p>
                        </div>
                        <div class="address hvr-bounce-in" v-for="(item,index) in $t('btmBar.link')" :key="index">
                           <a :href="item.href" target="_blank"> <span>{{item.name}}</span></a> 
                        </div>
                    </el-col>
                    <el-col :md="6" :sm="24" style="text-align: end;">
                        <el-col v-for="(item,index) in scans" :key="index" :xs="12" :md="12" class="scan-img hvr-bounce-in" @mouseover.native="onHoverCode(item.id)" @mouseout.native="onOutCode()">
                            <div class="scan-code" :style="{backgroundImage:'url('+  (scanCode == item.id? item.scan : item.logo) +')'}"></div>
                            <div style="font-size:4px;padding: 5px 0 10px;">{{item.title}}</div>
                        </el-col>
                    </el-col>
                </el-col>
                
            </el-col>
            
        </el-row >
        <el-row type="flex" justify="center">
            <el-col :md="22" class="version">
                <el-col style="font-size: 14px;padding: 5px;">
                    <p>{{$t('btmBar.version')}}</p>
                    <p style="margin: 0;">{{$t('btmBar.versionMsg')}}</p>
                </el-col>
            </el-col>
            
        </el-row>
    </div>
</template>

<script>
    export default{
        name:"btmBar",
        data() {
            return{
                scanCode :0,
                scanimg:require('@/assets/images/btm-logo.png'),
                code:require('@/assets/images/home/bottom-code.jpg'),
                scans:this.$t('btmBar.scans')
            }
        },
        methods:{
            onHoverCode(idx){
                this.scanCode = idx
            },
            onOutCode(){
                 this.scanCode = 0
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/mh.scss';
    .version{
        padding-top: 20px;
        border-top: 1px solid #cecece;
    }
    .btm-position{
        margin-top: 50px;
        background-color: #ebebeb;
        @media only screen and (max-width:992px){
            margin-top: 0px;
            .btm-logo{
                height: 30px;
            }
        }
        // margin-top: 100px;
    }
    a{
        font-size: $h-font-15;
        color: #000;
    }
    
    .all-address{
        @media only screen and (max-width:992px){
            padding: 20px 0;
            margin-top: 20px;
        }
        padding: 80px 0;
        .address{
            font-size: $h-font-15;
            & +.address{
                @media only screen and (max-width:992px){
                    margin-top: 6px;
                }
                margin-top: 20px;
            }
            p{
                padding: 0;
                margin: 0;
            }
            
            display: flex;
            flex-direction: column;
            &:first-child{
                font-size: $h-font-15; 
            }
            span{
                padding: 2px 0;
            }
        }
    }
    
    .link-m{
        @media only screen and (max-width:992px){
            padding: 20px 0;
        }
        .lineMethod{
           
            display: flex;
            
            @media only screen and (max-width:992px){
                padding-left: 0;
                flex-direction: row;
                align-items: center;
            }
            padding-left: 20px;
            flex-direction: column;
            span{
                font-size: $h-font-15;
                padding-bottom: 5px;
            }
            
            &+.lineMethod{
                @media only screen and (max-width:992px){
                    margin: 0;
                }
                margin-top: 20px;
            }
        }
    }
    
    .scan-img{
        
        display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
        .scan-code{
            transition: all 0.5s; 
            border: 1px solid rgba(0, 0, 0, 0.05);
            height: 120px;
            width: 120px;
            background-size: 100% 100%;
        }
        
    }
</style>